export default "Slip fantasien og kreativiteten løs og lav jeres egne flotte stammebåds-billeder med ild ombord! Ligesom i fortællingen om Ask, Liv og Pil.";